import * as _ from 'lodash';
import * as React from 'react';
import history from 'login-utils/history';
import * as deploymentConfig from 'login-utils/deploymentConfig';
import * as onboardingForm from 'login-utils/onboardingForm';
import States, { isState } from 'login-constants/states';

import LeftPane, { LeftPaneProps } from './LeftPane/LeftPane';

export function generateLeftPane(p: LeftPaneProps) {
  class GeneratedLeftPane extends React.Component<LeftPaneProps> {
    render() {
      return <LeftPane {...p} {...this.props} />;
    }
  }

  return GeneratedLeftPane;
}

export function getApplicationType(state?: ReduxState) {
  // TODO (hourann) AUTO-148: given the evolution of the login app into several mini-applications,
  // there is no single way to mark which flow the user is currently flowing through! this function
  // collects the different conditions in one place: what it returns is a LoanType, but it's not
  // necessarily the same as the loanType form field (might have been set in query string, etc.)
  if (isState(history.getCurrentLocation().pathname, States.ACCOUNT_OPENING)) {
    return 'ACCOUNT_OPENING';
  } else if (_.includes(deploymentConfig.get().supportedLoanTypes, 'CANADA_MORTGAGE')) {
    return 'CANADA_MORTGAGE';
  } else if (state && state.form && state.form.auto) {
    return 'AUTO';
  } else {
    if (state) {
      const onboardingFormState = onboardingForm.getLoanType(state);
      if (onboardingFormState) {
        return onboardingFormState;
      }
    }
    return 'MORTGAGE';
  }
}
